// Port de app/index.tsx — splash (GIF) + decisão do destino pós-splash.
import splashNova from "@/assets/images/splash_nova.png";
import Splash from "@/components/splash/Splash";
import { useAuth } from "@/contexts/AuthContext";
import { useRouter } from "@/navigation";
import AsyncStorage from "@/platform/async-storage";
import { useWindowDimensions } from "@/platform/dimensions";
import * as SplashScreen from "@/platform/splash-screen";
import { PERMISSIONS_COMPLETED_KEY, resolvePostSplashTarget } from "@/utils/appEnvironmentStorage";
import { useCallback, useEffect, useRef, useState } from "react";
import s from "./index.module.css";

const INTRO_SEEN_STORAGE_KEY = "@tirvumais:intro-seen";

export default function Index() {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const { isAuthenticated, isHydrated } = useAuth();
  const [ready, setReady] = useState(false);
  const [gifDone, setGifDone] = useState(false);
  const navegouRef = useRef(false);

  useEffect(() => {
    SplashScreen.preventAutoHideAsync();
    setReady(true);
  }, []);

  // Esconde o splash NATIVO só quando o GIF já está pintado na tela — assim a
  // transição splash-nativo → GIF é contínua (ambos no #294956), sem frame branco.
  const handleReady = useCallback(() => {
    SplashScreen.hideAsync().catch(() => {});
  }, []);

  const handleDone = useCallback(() => {
    setGifDone(true);
  }, []);

  // Navega só quando o GIF terminou E a hidratação acabou (pra usar isAuthenticated
  // correto). A hidratação roda em paralelo enquanto o GIF toca, então normalmente
  // não atrasa nada; se demorar, o GIF segura na tela até terminar (sem branco).
  useEffect(() => {
    if (!gifDone || !isHydrated || navegouRef.current) return;
    navegouRef.current = true;

    const goNext = async () => {
      // Sessão primeiro: logado vai direto para a Home, sem depender de nenhuma leitura.
      if (isAuthenticated) {
        router.replace("/(tabs)/home");
        return;
      }

      // Leitura que falha não pode prender o app no splash: na dúvida, mostra a intro e as
      // permissões de novo (inofensivo).
      const [introSeen, permissionsCompleted] = await Promise.all([
        AsyncStorage.getItem(INTRO_SEEN_STORAGE_KEY).catch(() => null),
        AsyncStorage.getItem(PERMISSIONS_COMPLETED_KEY).catch(() => null),
      ]);

      const target = await resolvePostSplashTarget({
        introSeen: introSeen === "true",
        permissionsCompleted: permissionsCompleted === "true",
      });

      switch (target) {
        case "intro":
          router.replace("/intro");
          return;
        case "permissions":
          router.replace("/permissions");
          return;
        case "environment-select":
          router.replace("/environment-select");
          return;
        case "onboarding":
        default:
          router.replace("/onboarding");
          return;
      }
    };

    goNext();
  }, [gifDone, isHydrated, isAuthenticated, router]);

  // Mostra o GIF IMEDIATAMENTE após a starting window (não espera a hidratação —
  // ela roda em paralelo). Enquanto o GIF não está pronto, mostra a logo_nova
  // centralizada sobre o #294956 (recolorida p/ casar com o fundo, sem quadrado).
  if (!ready)
    return (
      <div className={s.container}>
        <img
          src={splashNova}
          alt=""
          className={s.logo}
          style={{ width: width * 0.5, height: width * 0.5 }}
        />
      </div>
    );
  return <Splash onReady={handleReady} onDone={handleDone} />;
}
